import {createSelector} from 'helpers';

export const realityCheck = createSelector(
  [ state => state.clarity['reality-check'] ],
  ( values => ({
    'family-&-friends': 5,
    'health-&-fitness': 5,
    'love-&-romance': 5,
    'personal-growth': 5,
    'recreation-&-lifestyle': 5,
    'spirituality-&-faith': 5,
    'wealth-&-finances': 5,
    'work-&-career': 5,
    ...values,
  }))
);
